import { Dispatch, SetStateAction, createContext } from 'react';
import { FormOption } from 'types';

interface SelectContextData {
  selectInputRef: any;
  showOptions: boolean;
  setShowOptions: Dispatch<SetStateAction<boolean>>;
  option: FormOption;
  setOption: Dispatch<SetStateAction<FormOption>>;
  tagList: FormOption[];
  setTagList: Dispatch<SetStateAction<FormOption[]>>;
  inputText: string;
  setInputText: Dispatch<SetStateAction<string>>;
  searchable: boolean;
  setSearchable: Dispatch<SetStateAction<boolean>>;
}

export const SelectContext = createContext<SelectContextData>(
  {} as SelectContextData
);
